import React from 'react';
import { Route, Switch } from "react-router-dom";
import ListingList from "./listing-list/listing-list";
import ListingDetails from "./listing-details/listing-details";
import ListingApplication from "./listing-application/listing-application";

const Listing = () => {
  return (
    <Switch>
      <Route exact path="/listing">
        <ListingList />
      </Route>
      <Route path="/listing/application/:applicationId">
        <ListingApplication />
      </Route>
      <Route path="/listing/application/">
        <ListingApplication />
      </Route>
      <Route path="/listing/:applicationId">
        <ListingDetails />
      </Route>
    </Switch>
  )
}

export default Listing;



